/**
 * Videocall Entry-Point Handlers
 *
 * Thin glue that registers DOM event listeners and delegates to the
 * handler functions imported from videocallModal.js.
 */
const $ = jQuery;
const LIVE_CALL_HASH = '#live-call';

function hasLiveCallHash() {
    return (window.location.hash || '').toLowerCase() === LIVE_CALL_HASH;
}

function setLiveCallHash() {
    if (hasLiveCallHash()) return;

    const url = new URL(window.location.href);
    url.hash = LIVE_CALL_HASH;
    window.history.replaceState(window.history.state, document.title, url.toString());
}

function clearLiveCallHash() {
    if (!hasLiveCallHash()) return;

    const url = new URL(window.location.href);
    url.hash = '';
    window.history.replaceState(window.history.state, document.title, url.toString());
}

/**
 * Register all videocall event listeners on the document.
 * Called once during module initialization.
 *
 * @param {object} ctx  Shared context with all callbacks + mutable state
 */
export function registerEventListeners(ctx) {
    $(document).on('click', '.g-chat-btn-videocall', function (e) {
        e.preventDefault();
        ctx.handleClick($(this), { restoreFromHash: false });
    });

    $(document)
        .off('shown.bs.modal.videocallHash', '#growtypeChatVideoCallModal')
        .on('shown.bs.modal.videocallHash', '#growtypeChatVideoCallModal', setLiveCallHash)
        .off('hidden.bs.modal.videocallHash', '#growtypeChatVideoCallModal')
        .on('hidden.bs.modal.videocallHash', '#growtypeChatVideoCallModal', clearLiveCallHash);

    const openVideocallFromHash = function () {
        if (!hasLiveCallHash() || $('#growtypeChatVideoCallModal.show').length) return;

        const trigger = $('.g-chat-btn-videocall').first();
        if (trigger.length) {
            ctx.handleClick(trigger, { restoreFromHash: true });
        }
    };

    $(window)
        .off('hashchange.growtypeChatVideocall')
        .on('hashchange.growtypeChatVideocall', function () {
            if (hasLiveCallHash()) {
                openVideocallFromHash();
                return;
            }

            const modal = $('#growtypeChatVideoCallModal.show');
            if (modal.length && typeof modal.modal === 'function') {
                modal.modal('hide');
            }
        });

    window.setTimeout(openVideocallFromHash, 0);

    document.addEventListener("visibilitychange", function () {
        ctx.handleVisibility();
    });
}
